import { useEffect, useState } from "react";
import { CookiesKeys, UserCulture } from "../libs/enums";
import { setCookie } from "../utils/cookies";

export default function TranslationGate({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Set the cookie only if it doesn't exist
    if (!document.cookie.includes(CookiesKeys.userCulture)) {
      setCookie(CookiesKeys.userCulture, UserCulture.English);
    }
    setReady(true);
  }, []);

  if (!ready) return null; // or a loader

  return <>{children}</>;
}